import React, { useState } from "react";

import styles from "./CollapsableSection.module.css"

import Link from "../Link/Link"

function CollapsableSection(props) {

    const [showDiv, setShowDiv] = useState(true)

    function toggleShow() {
        setShowDiv(!showDiv)
    }

    return (
        <React.Fragment>
            <div className={styles.link_container}>
                <div onClick={toggleShow} className={styles.linkClickable}>
                    {props.collapseTitle}
                </div>
                {/* <Link color={props.color} hover={props.hover} onClick={toggleShow}>{props.collapseTitle}</Link> */}
            </div>
            <div>
                {
                    showDiv ? <div className={styles.invisible}>
                        {props.children}
                    </div> : <div className={styles.visible}>
                            {props.children}
                        </div>
                }
            </div>
        </React.Fragment>
    )
}

export default CollapsableSection;

